import { getAxios } from '@/utils/Utils'
import API from '@/utils/ApiConfig'

const processResponse = res => {
  if (res.meta.code === 200) {
    return res.data
  }
}

export default {
  getAll: (params = {}) => getAxios().get(API.SERVER + API.SERVICES_GET, { params }, API.CONFIG)
    .then(res => { return { services: res.data.data, pagination: res.data.pagination } })
    .catch(err => { throw err }),

  getAllCamps: () => getAxios().get(API.SERVER + API.CAMPS_GET, API.CONFIG)
    .then(res => { return { camps: res.data.data } })
    .catch(err => { throw err }),

  getAllPds: () => getAxios().get(API.SERVER + API.PD_GET, API.CONFIG)
    .then(res => { return { pds: res.data.data } })
    .catch(err => { throw err }),

  get: (serviceId) => getAxios().get(API.SERVER + API.SERVICE_GET.replace(':serviceId', serviceId), API.CONFIG)
    .then(res => processResponse(res.data))
    .catch(err => { throw err })
}



// WEBPACK FOOTER //
// ./src/services/ServiceService.js